// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var SortOrder;
(function (SortOrder) {
    SortOrder["UNSPECIFIED_ORDER"] = "UNSPECIFIED_ORDER";
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortOrder_index;
(function (SortOrder_index) {
    SortOrder_index[SortOrder_index["UNSPECIFIED_ORDER"] = 0] = "UNSPECIFIED_ORDER";
    SortOrder_index[SortOrder_index["ASC"] = 1] = "ASC";
    SortOrder_index[SortOrder_index["DESC"] = 2] = "DESC";
})(SortOrder_index || (SortOrder_index = {}));
export var PageDirection;
(function (PageDirection) {
    PageDirection["UNSPECIFIED_DIRECTION"] = "UNSPECIFIED_DIRECTION";
    PageDirection["NEXT"] = "NEXT";
    PageDirection["PREV"] = "PREV";
})(PageDirection || (PageDirection = {}));
export var PageDirection_index;
(function (PageDirection_index) {
    PageDirection_index[PageDirection_index["UNSPECIFIED_DIRECTION"] = 0] = "UNSPECIFIED_DIRECTION";
    PageDirection_index[PageDirection_index["NEXT"] = 1] = "NEXT";
    PageDirection_index[PageDirection_index["PREV"] = 2] = "PREV";
})(PageDirection_index || (PageDirection_index = {}));
